export default "__VITE_ASSET__DMOyCeNm__"